import QyRTemplate from "../components/templates/QyRTemplate"

const QyR = () => {
    return <QyRTemplate/>;
};

export default QyR;